import { Offer } from "../types";
import { CampaignOffer, Links, Option } from "../types/betData";
import clonedeep from "lodash.clonedeep";

const searchParams = new URLSearchParams(window.location.search);

function addKeyValue(link: string, key: string, value: string) {
  if (!link) return "";

  if (link.includes("?")) {
    return `${link}&${key}=${encodeURIComponent(value)}`;
  }

  return `${link}?${key}=${encodeURIComponent(value)}`;
}

export function addLinksClickUrl(links: Links, clickUrl: string): Links {
  if (clickUrl) {
    return Object.keys(links).reduce((updatedLinks, link) => {
      if (links[link] === "") {
        updatedLinks[link] = "";
        return updatedLinks;
      }

      updatedLinks[link] = addKeyValue(links[link], "clickUrl", clickUrl);

      return updatedLinks;
    }, {} as Links);
  }

  return links;
}

export function addOptionClickUrl(option: Option, clickUrl: string) {
  const updatedOption = { ...option };
  if (clickUrl) {
    updatedOption.betslipUrl = addKeyValue(
      updatedOption.betslipUrl,
      "clickUrl",
      clickUrl
    );
  }
  return updatedOption;
}

export function addOfferUrl(offer: Offer): Offer | CampaignOffer {
  const targetUrl = offer.link;
  const clickUrl = searchParams.get("clickUrl") || undefined;
  const _offer = clonedeep(offer);

  _offer.link = "https://links.fresh8.co";

  if (clickUrl) {
    _offer.link = addKeyValue(_offer.link, "clickUrl", clickUrl);
  }

  if (targetUrl) {
    _offer.link = addKeyValue(_offer.link, "targetUrl", targetUrl);
  }

  return _offer;
}
